import { ColumnspageBlock as ColumnsBlockTypes } from "@/payload-types";
import { Fragment } from "react";
import { CardBlock } from "./CardBlock";
import { MediaBlock } from "@onclicks/sharedcomponents/defaultTheme/blocks/MediaBlock";
import { MapBlock } from "@onclicks/sharedcomponents/defaultTheme/blocks/MapBlock";
import { ContentBlock } from "./ContentBlock";
import { RowsLayoutBlock } from "./RowsLayoutBlock";
import { ContactMainContainerBlock } from "./ContactMainContainerBlock";

const blockComponents = {
  cardBlock: CardBlock,
  mediaBlock: MediaBlock,
  map: MapBlock,
  content: ContentBlock,
  rowsLayout: RowsLayoutBlock,
  contact: ContactMainContainerBlock,
  archiveBlock: null,
  previewBoutique: null,
  categoryMedusa: null,
};

const ColumnsLayoutBlock: React.FC<ColumnsBlockTypes> = (props) => {
  const { items } = props;

  const hasBlocks = items && Array.isArray(items) && items.length > 0;

  if (!hasBlocks) return null;

  return (
    <Fragment>
      {/* Grid configuration:
          - grid-cols-1: Mobile (1 colonne)
          - md:grid-cols-2: Tablette/Desktop (2 colonnes)
          - gap-4: Espace entre les cards
      */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 py-3 w-full">
        {items.map((block, index) => {
          if (block && block.content && block.content[0] !== undefined) {
            const { blockType } = block?.content?.[0];

            if (blockType && blockType in blockComponents) {
              const Block = blockComponents[blockType];

              // Logique pour la largeur complète si un seul bloc
              // spans-2 si c'est le seul bloc dans la liste

              return (
                <div key={index} className={"md:col-span-1"}>
                  {/* @ts-expect-error mismatch types */}
                  <Block {...block.content[0]} disableInnerContainer />
                </div>
              );
            }
          }
          return null;
        })}
      </div>
    </Fragment>
  );
};

export { ColumnsLayoutBlock };
